////////////////////////////////////////////
// NAV LINKS — ONE TABLE BEHIND THE DESKTOP ROW AND THE MOBILE BOTTOM BAR
////////////////////////////////////////////
//
// EACH ITEM DECLARES WHERE IT APPEARS (desktop LINK ROW / mobile TAB BAR)
// AND, OPTIONALLY, A CUSTOM ACTIVE MATCHER — THE DEFAULT IS PATH-PREFIX
// (SO /create ALSO COVERS /create-instant). adminOnly ITEMS RENDER ONLY
// FOR THE admin ROLE.
import type { ComponentType } from "react";
import { AdminIcon, CreateIcon, HomeIcon, HowIcon, PadIcon, type NavIconProps } from "@/app/layout/nav/icons";

export interface NavLinkDef {
  to: string;
  label: string;
  Icon: ComponentType<NavIconProps>;
  desktop: boolean;
  mobile: boolean;
  adminOnly?: boolean;
  match?: (pathname: string, search: URLSearchParams) => boolean;
}

export const NAV_LINKS: NavLinkDef[] = [
  // HOME — MOBILE ONLY (THE LOGO COVERS IT ON DESKTOP). NOT ACTIVE ON THE
  // LAUNCH PAGE, WHICH SHARES "/" DISCRIMINATED BY ?launch
  { to: "/", label: "Home", Icon: HomeIcon, desktop: false, mobile: true, match: (p, s) => p === "/" && !s.get("launch") },
  { to: "/create", label: "Create a token", Icon: CreateIcon, desktop: true, mobile: true },
  { to: "/discover", label: "Launchpad", Icon: PadIcon, desktop: true, mobile: true },
  { to: "/howitworks", label: "How it works", Icon: HowIcon, desktop: true, mobile: true },
  { to: "/admin", label: "Admin", Icon: AdminIcon, desktop: true, mobile: true, adminOnly: true },
];

export function isActiveLink(l: NavLinkDef, pathname: string, search: URLSearchParams): boolean {

  if (l.match) return l.match(pathname, search);
  return pathname.startsWith(l.to);
}
